export default __webpack_public_path__ + "static/3-af48fca8254a334f709e99779ba82602.jpeg";